<template>
  <div class="ProductShippingFlashSell" v-if="transformProductFlashSell">
    <span>Vente Flash</span>
    <div class="ProductShipping-logo">
      <svg
        v-svg
        symbol="Clock"
        size="0 0 32 32"
        role="presentation"
        class="icon--inline Icon-clock"
      ></svg>
    </div>
    <Countdown
      :end="transformProductFlashSell"
      :class="coutdownClass"
      showDays
      showHours
      showMinutes
      showSeconds
    ></Countdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Countdown from "countdown-vue";

import "@/includes/Product/ProductShippingFlashSell/ProductShippingFlashSell.scss";

export default {
  name: "ProductShippingFlashSell",

  data () {
    return {
      coutdownClass: "",
    };
  },

  components: {
    Countdown,
  },

  computed: {
    ...mapGetters({ productFlashSell: "getProductFlashSell" }),
    // TODO: improve this part
    transformProductFlashSell () {
      if (this.productFlashSell && this.productFlashSell.endFlashSell !== "") {
        let now = this.$dayjs(new Date());
        let endDate = this.$dayjs(this.productFlashSell.endFlashSell);
        if (endDate.diff(now, "days") > 0) {
          this.coutdownClass = "hasDays";
        }
        if (endDate.isAfter(now)) {
          return endDate.format();
        }
      }
      return false;
    },
  },
};
</script>
